module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-7.93175c75.jpg";